export const APPOINTMENT = 'appointment';
export const HOUSE_CALL = 'house_call';
export const CHAT_CONSULT = 'chat_consult';
export const VIDEO_CONSULT = 'video_consult';
export const LAB_TEST = 'lab_test';
export const TELECONSULT = 'teleconsult';
export const LAB_REPORT = 'lab_report';
export const PRESCRIPTION = 'prescription';
export const EMC = 'emc';
export const NEWS_FEED = 'news_feed';
export const MANADR_PRODUCT = 'manadr-product';
export const UNKNOWN = 'unknown';
export const CONSULT_SUMMARY = 'consult_summary';
